/* Healthy Store Tech — small progressive enhancements. The store works without this file. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hero goal scanner: choose a goal tab to show its products in place.
  document.querySelectorAll('[data-scanner]').forEach(function (scanner) {
    var tabs = Array.prototype.slice.call(scanner.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(scanner.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || tabs.length !== panels.length) return;

    function activate(index, focus) {
      tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
        tab.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });
      if (focus) tabs[index].focus();
      if (!reduceMotion) {
        scanner.classList.remove('is-scanning');
        void scanner.offsetWidth; // restart the one-shot beam animation
        scanner.classList.add('is-scanning');
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
        event.preventDefault();
        activate(i, false);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          event.preventDefault();
          activate(next, true);
        }
      });
    });

    tabs.forEach(function (tab, i) { tab.tabIndex = i === 0 ? 0 : -1; });
    if (!reduceMotion) scanner.classList.add('scan-on-load');
  });

  // Product gallery: swap the main image when a thumbnail is chosen.
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-src');
        main.srcset = '';
        main.alt = thumb.getAttribute('data-alt') || '';
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // Buy box: update the headline price and the URL when a variant is chosen.
  document.querySelectorAll('[data-buy-box]').forEach(function (box) {
    var priceTarget = box.querySelector('[data-price-target]');
    var button = box.querySelector('[data-add-button]');
    var updatesUrl = box.hasAttribute('data-update-url');
    box.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var html = input.getAttribute('data-price-html');
        if (priceTarget && html) priceTarget.innerHTML = html;
        if (button) {
          var available = input.getAttribute('data-available') === 'true';
          button.disabled = !available;
          button.textContent = available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-soldout');
        }
        if (updatesUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  });

  // Announcement bar: tap a discount code to copy it.
  document.querySelectorAll('[data-copy]').forEach(function (chip) {
    var original = chip.textContent;
    chip.addEventListener('click', function () {
      var code = chip.getAttribute('data-copy');
      function done() {
        chip.textContent = 'Copied';
        window.setTimeout(function () { chip.textContent = original; }, 1600);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {});
      }
    });
  });

  // Sticky Add-to-cart bar (phones): appears once the main button scrolls out of view.
  document.querySelectorAll('[data-sticky-cart]').forEach(function (bar) {
    var box = document.querySelector('[data-buy-box]');
    var mainButton = box && box.querySelector('[data-add-button]');
    var priceTarget = box && box.querySelector('[data-price-target]');
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var stickyButton = bar.querySelector('[data-sticky-button]');
    if (!mainButton || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      var above = entries[0].boundingClientRect.top < 0;
      bar.hidden = visible || !above;
    }).observe(mainButton);

    // Keep the bar in step with the chosen variant.
    function sync() {
      if (stickyPrice && priceTarget) stickyPrice.innerHTML = priceTarget.innerHTML;
      if (stickyButton) {
        stickyButton.disabled = mainButton.disabled;
        stickyButton.textContent = mainButton.textContent.trim();
      }
    }
    if (box) box.addEventListener('change', function () { window.setTimeout(sync, 0); });
  });

  // Scroll reveal: cards fade up as they enter the screen.
  if ('IntersectionObserver' in window && !reduceMotion) {
    var targets = document.querySelectorAll('.goal-card, .product-card, .trust__row > div, [data-reveal], .section-head');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          el.classList.add('is-in'); io.unobserve(el);
          window.setTimeout(function () { el.classList.remove('reveal', 'is-in'); el.style.removeProperty('--d'); }, 1000); // hand hover transitions back to normal
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el, i) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) return; // already on screen: leave visible
      el.classList.add('reveal');
      el.style.setProperty('--d', ((i % 4) * 70) + 'ms');
      io.observe(el);
    });
    // Failsafe: never leave anything hidden if the observer is slow or blocked.
    window.setTimeout(function () {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    }, 6000);
  }

  // Collection sort: go to the chosen sort order.
  var sort = document.querySelector('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
